// removed by extract-text-webpack-plugin
module.exports = {"block":"_1am6eGOOw6YYArgkqTs1De","top":"_38YjptIcCwFQXUCHtJNpLF","title":"_2xTI2M93DPBHehiJ8C4RLk","note":"_13U7veVX8XuTgS8RT-gOPf","lead":"_2rCk6EBM20XACBXvspjQgA","line":"_1dp4eNtYTO7QiQM_RVqNDK","mark":"_20STwbXTjaeJ3nFTmIFlD2","pmark":"_4aLoD35JdNQN7mBI43G0P","ssl":"_1Vp8AiSm_MICbk7oqZ7AX0","form":"_25PMaoSjjYzcdGW7IREQfS","name":"SLH9w_yj3kYPnqbIu4At4","email":"_1r1qJhDO1Bby3DpPykDtxj","agree":"_3ReeFX1DuA3c0Hdu1PNh-Y","error":"_2gGQKewZRdr_-8Nt-EiM6H","button":"QEUTGxmAe8nEFx4C4cdiR"};


//////////////////
// WEBPACK FOOTER
// ./src/css/screens/registration.css
// module id = 56
// module chunks = 0